<template>
  <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <path
        d="M9.79 25.577h10.668V6.902H9.79v18.675zm19.824 3.95H.247c-.136 0-.247.103-.247.229s.11.228.247.228h29.367c.137 0 .247-.102.247-.228s-.11-.228-.247-.228M9.337 2.735v24H4.596v-24h4.741zm16.315 0v24h-4.741v-24h4.741zM29.614 0c.137 0 .247.102.247.228s-.11.228-.247.228H.247C.111.456 0 .354 0 .228S.11 0 .247 0z"
        fill="currentColor"
        fill-rule="nonzero"
      />
      <path
        d="M9.337 27.409v2.119H4.596v-2.119h4.741zm16.315 0v2.119h-4.741v-2.119h4.741zM9.337.456v1.732H4.596V.456h4.741zm16.315 0v1.732h-4.741V.456h4.741z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
